// Predefined location data to prevent typos and ensure accuracy

export const COUNTRIES = [
  { value: 'United States', label: 'United States' },
  { value: 'Canada', label: 'Canada' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'Germany', label: 'Germany' },
  { value: 'France', label: 'France' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'Sweden', label: 'Sweden' },
  { value: 'Norway', label: 'Norway' },
  { value: 'Denmark', label: 'Denmark' },
  { value: 'Ireland', label: 'Ireland' },
  { value: 'Australia', label: 'Australia' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'India', label: 'India' },
  { value: 'Japan', label: 'Japan' },
  { value: 'South Korea', label: 'South Korea' },
  { value: 'United Arab Emirates', label: 'United Arab Emirates' },
  { value: 'Israel', label: 'Israel' }
];

// Countries available for Hybrid/Onsite positions
export const HYBRID_ONSITE_COUNTRIES = [
  { value: 'United States', label: 'United States' },
  { value: 'India', label: 'India' },
  { value: 'Canada', label: 'Canada' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'EMEA', label: 'EMEA (Europe, Middle East, Africa)' }
];

export const US_STATES = [
  { value: 'California', label: 'California' },
  { value: 'Texas', label: 'Texas' },
  { value: 'New York', label: 'New York' },
  { value: 'Florida', label: 'Florida' },
  { value: 'Illinois', label: 'Illinois' },
  { value: 'Pennsylvania', label: 'Pennsylvania' },
  { value: 'Ohio', label: 'Ohio' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'North Carolina', label: 'North Carolina' },
  { value: 'Michigan', label: 'Michigan' },
  { value: 'New Jersey', label: 'New Jersey' },
  { value: 'Virginia', label: 'Virginia' },
  { value: 'Washington', label: 'Washington' },
  { value: 'Arizona', label: 'Arizona' },
  { value: 'Massachusetts', label: 'Massachusetts' },
  { value: 'Tennessee', label: 'Tennessee' },
  { value: 'Indiana', label: 'Indiana' },
  { value: 'Missouri', label: 'Missouri' },
  { value: 'Maryland', label: 'Maryland' },
  { value: 'Wisconsin', label: 'Wisconsin' },
  { value: 'Colorado', label: 'Colorado' },
  { value: 'Minnesota', label: 'Minnesota' },
  { value: 'South Carolina', label: 'South Carolina' },
  { value: 'Alabama', label: 'Alabama' },
  { value: 'Louisiana', label: 'Louisiana' },
  { value: 'Kentucky', label: 'Kentucky' },
  { value: 'Oregon', label: 'Oregon' },
  { value: 'Oklahoma', label: 'Oklahoma' },
  { value: 'Connecticut', label: 'Connecticut' },
  { value: 'Utah', label: 'Utah' },
  { value: 'Iowa', label: 'Iowa' },
  { value: 'Nevada', label: 'Nevada' },
  { value: 'Arkansas', label: 'Arkansas' },
  { value: 'Mississippi', label: 'Mississippi' },
  { value: 'Kansas', label: 'Kansas' },
  { value: 'New Mexico', label: 'New Mexico' },
  { value: 'Nebraska', label: 'Nebraska' },
  { value: 'Idaho', label: 'Idaho' },
  { value: 'Hawaii', label: 'Hawaii' },
  { value: 'New Hampshire', label: 'New Hampshire' },
  { value: 'Maine', label: 'Maine' },
  { value: 'Rhode Island', label: 'Rhode Island' },
  { value: 'Montana', label: 'Montana' },
  { value: 'Delaware', label: 'Delaware' },
  { value: 'South Dakota', label: 'South Dakota' },
  { value: 'North Dakota', label: 'North Dakota' },
  { value: 'Alaska', label: 'Alaska' },
  { value: 'Vermont', label: 'Vermont' },
  { value: 'Wyoming', label: 'Wyoming' }
];

// Major tech hubs and cities by state
export const US_CITIES_BY_STATE = {
  'California': ['San Francisco', 'Los Angeles', 'San Diego', 'San Jose', 'Sacramento', 'Oakland', 'Fresno', 'Bakersfield', 'Riverside', 'Stockton', 'Modesto', 'Irvine', 'Santa Clara', 'Sunnyvale', 'Palo Alto', 'Mountain View', 'Cupertino', 'Redwood City', 'Berkeley', 'Pasadena', 'Fremont', 'Santa Monica', 'Anaheim', 'Long Beach', 'Glendale', 'Huntington Beach', 'Santa Clarita', 'Oxnard', 'Chula Vista', 'Fontana', 'Moreno Valley', 'San Bernardino', 'Santa Rosa', 'Oceanside', 'Rancho Cucamonga', 'Ontario', 'Lancaster', 'Palmdale', 'Salinas', 'Pomona', 'Hayward', 'Escondido', 'Corona', 'Torrance', 'Sunnyvale', 'Concord', 'Visalia', 'Roseville', 'Thousand Oaks', 'Simi Valley', 'Vallejo', 'Victorville', 'Orange', 'Santa Barbara', 'Elk Grove', 'Carlsbad', 'Fairfield', 'Ventura', 'Temecula', 'Antioch', 'Daly City', 'Richmond', 'San Mateo', 'San Leandro', 'Burbank', 'Inglewood', 'Rialto', 'El Cajon', 'South Gate', 'Downey', 'Menifee', 'Costa Mesa', 'Jurupa Valley', 'West Covina', 'Norwalk', 'Murrieta'],
  'Texas': ['Austin', 'Dallas', 'Houston', 'San Antonio', 'Fort Worth', 'Plano', 'Arlington', 'Frisco', 'Irving', 'McKinney', 'El Paso', 'Corpus Christi', 'Lubbock', 'Laredo', 'Garland', 'Amarillo', 'Grand Prairie', 'Brownsville', 'Pasadena', 'Mesquite', 'Killeen', 'Waco', 'Carrollton', 'Denton', 'Midland', 'Abilene', 'Beaumont', 'Round Rock', 'Odessa', 'Wichita Falls', 'Richardson', 'Lewisville', 'Tyler', 'College Station', 'Pearland', 'San Angelo', 'Allen', 'League City', 'Sugar Land', 'Longview', 'Edinburg', 'Mission', 'Bryan', 'Pharr', 'Temple', 'Missouri City', 'Flower Mound', 'Harlingen', 'North Richland Hills', 'Cedar Park'],
  'New York': ['New York City', 'Buffalo', 'Rochester', 'Albany', 'Syracuse', 'Brooklyn', 'Manhattan', 'Queens', 'Bronx', 'Yonkers', 'White Plains', 'New Rochelle', 'Staten Island', 'Hempstead', 'Binghamton', 'Niagara Falls', 'Freeport', 'Valley Stream', 'Long Beach', 'Troy', 'Schenectady', 'Utica', 'Mount Vernon', 'New City', 'West Babylon', 'Port Chester', 'Saratoga Springs'],
  'Florida': ['Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Fort Lauderdale', 'St. Petersburg', 'Tallahassee', 'Boca Raton', 'West Palm Beach', 'Gainesville', 'Clearwater', 'Cape Coral', 'Hialeah', 'Port St. Lucie', 'Pembroke Pines', 'Hollywood', 'Miramar', 'Coral Springs', 'Lehigh Acres', 'Miami Gardens', 'Palm Bay', 'Davie', 'Lakeland', 'Pompano Beach', 'Deerfield Beach', 'Boynton Beach', 'Delray Beach', 'Fort Myers', 'Naples', 'Sarasota', 'Brandon', 'Kissimmee', 'Daytona Beach', 'Largo', 'Plantation', 'Sunrise'],
  'Illinois': ['Chicago', 'Aurora', 'Naperville', 'Joliet', 'Rockford', 'Springfield', 'Peoria', 'Elgin', 'Schaumburg', 'Champaign', 'Evanston', 'Decatur', 'Waukegan', 'Cicero', 'Bloomington', 'Arlington Heights', 'Bolingbrook', 'Palatine', 'Skokie', 'Des Plaines', 'Orland Park', 'Tinley Park', 'Oak Lawn', 'Berwyn', 'Mount Prospect', 'Wheaton', 'Normal', 'Oak Park'],
  'Washington': ['Seattle', 'Spokane', 'Tacoma', 'Bellevue', 'Redmond', 'Kirkland', 'Olympia', 'Everett', 'Vancouver', 'Kent', 'Renton', 'Spokane Valley', 'Federal Way', 'Yakima', 'Bellingham', 'Kennewick', 'Auburn', 'Pasco', 'Marysville', 'Lakewood', 'Richland', 'Sammamish', 'Bothell', 'Lynnwood'],
  'Massachusetts': ['Boston', 'Cambridge', 'Worcester', 'Springfield', 'Lowell', 'Quincy', 'Newton', 'Somerville', 'Waltham', 'Framingham', 'Lynn', 'Lawrence', 'Brookline', 'New Bedford', 'Brockton', 'Fall River', 'Malden', 'Medford', 'Haverhill', 'Revere', 'Peabody', 'Methuen', 'Taunton', 'Weymouth', 'Chicopee', 'Arlington', 'Attleboro'],
  'Pennsylvania': ['Philadelphia', 'Pittsburgh', 'Harrisburg', 'Allentown', 'Erie', 'Reading', 'Scranton', 'Lancaster', 'Bethlehem', 'York', 'State College', 'Wilkes-Barre', 'Chester', 'Easton', 'Altoona', 'Lebanon', 'Johnstown', 'Williamsport', 'Chambersburg', 'King of Prussia', 'Monroeville'],
  'Arizona': ['Phoenix', 'Tucson', 'Mesa', 'Chandler', 'Scottsdale', 'Tempe', 'Gilbert', 'Glendale', 'Peoria', 'Surprise', 'Yuma', 'Avondale', 'Goodyear', 'Flagstaff', 'Buckeye', 'Lake Havasu City', 'Casa Grande', 'Sierra Vista', 'Prescott', 'Maricopa'],
  'Colorado': ['Denver', 'Colorado Springs', 'Aurora', 'Boulder', 'Fort Collins', 'Lakewood', 'Thornton', 'Arvada', 'Westminster', 'Pueblo', 'Centennial', 'Highlands Ranch', 'Greeley', 'Longmont', 'Loveland', 'Broomfield', 'Grand Junction', 'Castle Rock', 'Parker', 'Commerce City'],
  'Georgia': ['Atlanta', 'Augusta', 'Columbus', 'Savannah', 'Athens', 'Sandy Springs', 'Alpharetta', 'Marietta', 'Macon', 'Roswell', 'Johns Creek', 'Warner Robins', 'Smyrna', 'Dunwoody', 'Valdosta', 'East Point', 'Peachtree City', 'Kennesaw', 'Newnan', 'Duluth'],
  'North Carolina': ['Charlotte', 'Raleigh', 'Durham', 'Greensboro', 'Winston-Salem', 'Chapel Hill', 'Cary', 'Wilmington', 'Fayetteville', 'High Point', 'Asheville', 'Concord', 'Gastonia', 'Greenville', 'Jacksonville', 'Huntersville', 'Apex', 'Kannapolis', 'Wake Forest', 'Burlington'],
  'Oregon': ['Portland', 'Eugene', 'Salem', 'Gresham', 'Hillsboro', 'Beaverton', 'Bend', 'Corvallis', 'Medford', 'Springfield', 'Tigard', 'Lake Oswego', 'Keizer', 'Grants Pass', 'Oregon City', 'McMinnville', 'Redmond', 'Tualatin', 'West Linn', 'Woodburn'],
  'Virginia': ['Virginia Beach', 'Arlington', 'Richmond', 'Alexandria', 'Reston', 'Norfolk', 'Chesapeake', 'Newport News', 'Hampton', 'Portsmouth', 'Roanoke', 'Suffolk', 'Lynchburg', 'Harrisonburg', 'Leesburg', 'Charlottesville', 'Blacksburg', 'Danville', 'Manassas', 'Fredericksburg', 'Winchester', 'Salem'],
  'Maryland': ['Baltimore', 'Rockville', 'Bethesda', 'Annapolis', 'Silver Spring', 'Columbia', 'Frederick'],
  'Minnesota': ['Minneapolis', 'St. Paul', 'Rochester', 'Bloomington', 'Duluth', 'St. Cloud', 'Brooklyn Park', 'Plymouth', 'Woodbury', 'Maple Grove', 'Blaine', 'Lakeville', 'Eagan', 'Burnsville', 'Eden Prairie', 'Minnetonka', 'Apple Valley', 'Edina', 'St. Louis Park', 'Moorhead'],
  'Utah': ['Salt Lake City', 'Provo', 'West Valley City', 'West Jordan', 'Orem', 'Sandy', 'Ogden', 'St. George', 'Layton', 'Taylorsville', 'South Jordan', 'Lehi', 'Logan', 'Murray', 'Draper', 'Bountiful', 'Riverton', 'Roy', 'Spanish Fork', 'Pleasant Grove'],
  'Nevada': ['Las Vegas', 'Henderson', 'Reno', 'Carson City', 'Sparks', 'North Las Vegas', 'Enterprise', 'Spring Valley', 'Sunrise Manor', 'Paradise', 'Pahrump', 'Summerlin'],
  'Ohio': ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton', 'Parma', 'Canton', 'Youngstown', 'Lorain', 'Hamilton', 'Springfield', 'Kettering', 'Elyria', 'Lakewood', 'Cuyahoga Falls', 'Middletown', 'Euclid', 'Newark', 'Mansfield', 'Mentor', 'Beavercreek', 'Dublin', 'Cleveland Heights'],
  'Michigan': ['Detroit', 'Grand Rapids', 'Ann Arbor', 'Lansing', 'Sterling Heights', 'Warren', 'Flint', 'Dearborn', 'Livonia', 'Canton', 'Troy', 'Westland', 'Farmington Hills', 'Kalamazoo', 'Wyoming', 'Southfield', 'Rochester Hills', 'Taylor', 'St. Clair Shores', 'Pontiac', 'Royal Oak', 'Novi', 'Dearborn Heights'],
  'New Jersey': ['Newark', 'Jersey City', 'Paterson', 'Elizabeth', 'Edison', 'Trenton', 'Woodbridge', 'Lakewood', 'Toms River', 'Hamilton', 'Clifton', 'Camden', 'Brick', 'Cherry Hill', 'Passaic', 'Union City', 'Bayonne', 'East Orange', 'Vineland', 'Hoboken', 'New Brunswick', 'Plainfield', 'West New York', 'Perth Amboy'],
  'Tennessee': ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Clarksville', 'Franklin', 'Murfreesboro', 'Jackson', 'Johnson City', 'Bartlett', 'Hendersonville', 'Kingsport', 'Collierville', 'Smyrna', 'Cleveland', 'Brentwood', 'Germantown'],
  'Indiana': ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Carmel', 'Fishers', 'Bloomington', 'Hammond', 'Gary', 'Muncie', 'Lafayette', 'Terre Haute', 'Kokomo', 'Anderson', 'Noblesville', 'Greenwood', 'Elkhart', 'Mishawaka', 'Lawrence', 'Jeffersonville'],
  'Missouri': ['Kansas City', 'St. Louis', 'Springfield', 'Columbia', 'Independence', 'Lee\'s Summit', 'O\'Fallon', 'St. Joseph', 'St. Charles', 'Blue Springs', 'St. Peters', 'Florissant', 'Joplin', 'Chesterfield', 'Jefferson City', 'Cape Girardeau'],
  'Wisconsin': ['Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Racine', 'Appleton', 'Waukesha', 'Eau Claire', 'Oshkosh', 'Janesville', 'West Allis', 'La Crosse', 'Sheboygan', 'Wauwatosa', 'Fond du Lac', 'New Berlin', 'Wausau', 'Brookfield', 'Greenfield', 'Beloit'],
  'South Carolina': ['Charleston', 'Columbia', 'Greenville', 'Myrtle Beach', 'Spartanburg'],
  'Alabama': ['Birmingham', 'Montgomery', 'Mobile', 'Huntsville', 'Tuscaloosa'],
  'Louisiana': ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Lake Charles'],
  'Kentucky': ['Louisville', 'Lexington', 'Bowling Green', 'Owensboro', 'Covington'],
  'Oklahoma': ['Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Lawton'],
  'Connecticut': ['Hartford', 'New Haven', 'Stamford', 'Bridgeport', 'Waterbury'],
  'Iowa': ['Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City', 'Iowa City'],
  'Arkansas': ['Little Rock', 'Fort Smith', 'Fayetteville', 'Springdale', 'Jonesboro'],
  'Mississippi': ['Jackson', 'Gulfport', 'Southaven', 'Hattiesburg', 'Biloxi'],
  'Kansas': ['Wichita', 'Overland Park', 'Kansas City', 'Topeka', 'Olathe'],
  'New Mexico': ['Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe', 'Roswell'],
  'Nebraska': ['Omaha', 'Lincoln', 'Bellevue', 'Grand Island'],
  'Idaho': ['Boise', 'Meridian', 'Nampa', 'Idaho Falls', 'Pocatello'],
  'Hawaii': ['Honolulu', 'Hilo', 'Kailua', 'Kapolei', 'Pearl City'],
  'New Hampshire': ['Manchester', 'Nashua', 'Concord', 'Derry', 'Dover'],
  'Maine': ['Portland', 'Lewiston', 'Bangor', 'South Portland', 'Auburn'],
  'Rhode Island': ['Providence', 'Warwick', 'Cranston', 'Pawtucket', 'Woonsocket'],
  'Montana': ['Billings', 'Missoula', 'Great Falls', 'Bozeman', 'Butte'],
  'Delaware': ['Wilmington', 'Dover', 'Newark', 'Middletown', 'Smyrna'],
  'South Dakota': ['Sioux Falls', 'Rapid City', 'Aberdeen', 'Brookings'],
  'North Dakota': ['Fargo', 'Bismarck', 'Grand Forks', 'Minot'],
  'Alaska': ['Anchorage', 'Fairbanks', 'Juneau', 'Sitka', 'Ketchikan'],
  'Vermont': ['Burlington', 'South Burlington', 'Rutland', 'Barre', 'Montpelier'],
  'Wyoming': ['Cheyenne', 'Casper', 'Laramie', 'Gillette', 'Rock Springs']
};

// Canadian Provinces (All 10 provinces and 3 territories)
export const CANADIAN_PROVINCES = [
  { value: 'Ontario', label: 'Ontario' },
  { value: 'British Columbia', label: 'British Columbia' },
  { value: 'Quebec', label: 'Quebec' },
  { value: 'Alberta', label: 'Alberta' },
  { value: 'Manitoba', label: 'Manitoba' },
  { value: 'Saskatchewan', label: 'Saskatchewan' },
  { value: 'Nova Scotia', label: 'Nova Scotia' },
  { value: 'New Brunswick', label: 'New Brunswick' },
  { value: 'Newfoundland and Labrador', label: 'Newfoundland and Labrador' },
  { value: 'Prince Edward Island', label: 'Prince Edward Island' },
  { value: 'Yukon', label: 'Yukon' },
  { value: 'Northwest Territories', label: 'Northwest Territories' },
  { value: 'Nunavut', label: 'Nunavut' }
];

export const CANADA_CITIES_BY_PROVINCE = {
  'Ontario': ['Toronto', 'Ottawa', 'Mississauga', 'Brampton', 'Hamilton', 'London', 'Markham', 'Vaughan', 'Kitchener', 'Windsor', 'Burlington', 'Oakville', 'Richmond Hill', 'Barrie', 'Oshawa', 'St. Catharines', 'Cambridge', 'Waterloo', 'Guelph'],
  'British Columbia': ['Vancouver', 'Surrey', 'Burnaby', 'Richmond', 'Abbotsford', 'Coquitlam', 'Victoria', 'Kelowna', 'Kamloops', 'Nanaimo', 'Prince George', 'Chilliwack', 'Vernon'],
  'Quebec': ['Montreal', 'Quebec City', 'Laval', 'Gatineau', 'Longueuil', 'Sherbrooke', 'Saguenay', 'Levis', 'Trois-Rivieres', 'Terrebonne'],
  'Alberta': ['Calgary', 'Edmonton', 'Red Deer', 'Lethbridge', 'St. Albert', 'Medicine Hat', 'Grande Prairie', 'Airdrie', 'Spruce Grove', 'Fort McMurray'],
  'Manitoba': ['Winnipeg', 'Brandon', 'Steinbach', 'Thompson', 'Portage la Prairie'],
  'Saskatchewan': ['Saskatoon', 'Regina', 'Prince Albert', 'Moose Jaw', 'Swift Current'],
  'Nova Scotia': ['Halifax', 'Dartmouth', 'Sydney', 'Truro', 'New Glasgow'],
  'New Brunswick': ['Moncton', 'Saint John', 'Fredericton', 'Dieppe', 'Miramichi'],
  'Newfoundland and Labrador': ['St. John\'s', 'Mount Pearl', 'Corner Brook', 'Conception Bay South'],
  'Prince Edward Island': ['Charlottetown', 'Summerside', 'Stratford'],
  'Yukon': ['Whitehorse', 'Dawson City', 'Watson Lake'],
  'Northwest Territories': ['Yellowknife', 'Hay River', 'Inuvik'],
  'Nunavut': ['Iqaluit', 'Rankin Inlet', 'Arviat']
};

// UK Regions/Cities
export const UK_REGIONS = [
  { value: 'England', label: 'England' },
  { value: 'Scotland', label: 'Scotland' },
  { value: 'Wales', label: 'Wales' },
  { value: 'Northern Ireland', label: 'Northern Ireland' }
];

export const UK_CITIES_BY_REGION = {
  'England': ['London', 'Manchester', 'Birmingham', 'Leeds', 'Liverpool', 'Bristol', 'Newcastle', 'Sheffield', 'Cambridge', 'Oxford', 'Brighton', 'Reading', 'Nottingham', 'Southampton', 'Leicester', 'Coventry', 'Bradford', 'Edinburgh', 'Milton Keynes', 'Portsmouth', 'Sunderland', 'Norwich', 'Luton', 'Wolverhampton', 'Plymouth', 'York', 'Bournemouth', 'Bath', 'Exeter', 'Cheltenham', 'Guildford', 'Slough', 'Basingstoke'],
  'Scotland': ['Edinburgh', 'Glasgow', 'Aberdeen', 'Dundee', 'Inverness', 'Stirling', 'Perth'],
  'Wales': ['Cardiff', 'Swansea', 'Newport', 'Wrexham', 'Barry', 'Caerphilly'],
  'Northern Ireland': ['Belfast', 'Derry', 'Lisburn', 'Newry', 'Armagh']
};

// Indian States (All 28 states + 8 UTs)
export const INDIAN_STATES = [
  { value: 'Andhra Pradesh', label: 'Andhra Pradesh' },
  { value: 'Arunachal Pradesh', label: 'Arunachal Pradesh' },
  { value: 'Assam', label: 'Assam' },
  { value: 'Bihar', label: 'Bihar' },
  { value: 'Chhattisgarh', label: 'Chhattisgarh' },
  { value: 'Goa', label: 'Goa' },
  { value: 'Gujarat', label: 'Gujarat' },
  { value: 'Haryana', label: 'Haryana' },
  { value: 'Himachal Pradesh', label: 'Himachal Pradesh' },
  { value: 'Jharkhand', label: 'Jharkhand' },
  { value: 'Karnataka', label: 'Karnataka' },
  { value: 'Kerala', label: 'Kerala' },
  { value: 'Madhya Pradesh', label: 'Madhya Pradesh' },
  { value: 'Maharashtra', label: 'Maharashtra' },
  { value: 'Manipur', label: 'Manipur' },
  { value: 'Meghalaya', label: 'Meghalaya' },
  { value: 'Mizoram', label: 'Mizoram' },
  { value: 'Nagaland', label: 'Nagaland' },
  { value: 'Odisha', label: 'Odisha' },
  { value: 'Punjab', label: 'Punjab' },
  { value: 'Rajasthan', label: 'Rajasthan' },
  { value: 'Sikkim', label: 'Sikkim' },
  { value: 'Tamil Nadu', label: 'Tamil Nadu' },
  { value: 'Telangana', label: 'Telangana' },
  { value: 'Tripura', label: 'Tripura' },
  { value: 'Uttar Pradesh', label: 'Uttar Pradesh' },
  { value: 'Uttarakhand', label: 'Uttarakhand' },
  { value: 'West Bengal', label: 'West Bengal' },
  { value: 'Andaman and Nicobar Islands', label: 'Andaman and Nicobar Islands' },
  { value: 'Chandigarh', label: 'Chandigarh' },
  { value: 'Dadra and Nagar Haveli and Daman and Diu', label: 'Dadra and Nagar Haveli and Daman and Diu' },
  { value: 'Delhi', label: 'Delhi (NCR)' },
  { value: 'Jammu and Kashmir', label: 'Jammu and Kashmir' },
  { value: 'Ladakh', label: 'Ladakh' },
  { value: 'Lakshadweep', label: 'Lakshadweep' },
  { value: 'Puducherry', label: 'Puducherry' }
];

export const INDIA_CITIES_BY_STATE = {
  'Andhra Pradesh': ['Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool', 'Tirupati', 'Kakinada', 'Rajahmundry'],
  'Arunachal Pradesh': ['Itanagar', 'Naharlagun', 'Pasighat'],
  'Assam': ['Guwahati', 'Silchar', 'Dibrugarh', 'Jorhat', 'Nagaon', 'Tezpur'],
  'Bihar': ['Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Purnia', 'Darbhanga'],
  'Chhattisgarh': ['Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Durg'],
  'Goa': ['Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda'],
  'Gujarat': ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar', 'Gandhinagar', 'Anand'],
  'Haryana': ['Gurgaon', 'Faridabad', 'Ghaziabad', 'Panipat', 'Ambala', 'Yamunanagar', 'Rohtak', 'Hisar', 'Karnal', 'Sonipat'],
  'Himachal Pradesh': ['Shimla', 'Dharamshala', 'Solan', 'Mandi', 'Kullu', 'Manali'],
  'Jharkhand': ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Deoghar'],
  'Karnataka': ['Bangalore', 'Mysore', 'Mangalore', 'Hubli', 'Belgaum', 'Dharwad', 'Shimoga', 'Tumkur', 'Gulbarga'],
  'Kerala': ['Kochi', 'Thiruvananthapuram', 'Kozhikode', 'Thrissur', 'Kannur', 'Kollam', 'Palakkad', 'Alappuzha'],
  'Madhya Pradesh': ['Bhopal', 'Indore', 'Gwalior', 'Jabalpur', 'Ujjain', 'Sagar', 'Dewas'],
  'Maharashtra': ['Mumbai', 'Pune', 'Nagpur', 'Thane', 'Nashik', 'Aurangabad', 'Solapur', 'Kolhapur', 'Navi Mumbai'],
  'Manipur': ['Imphal', 'Thoubal', 'Bishnupur'],
  'Meghalaya': ['Shillong', 'Tura', 'Nongstoin'],
  'Mizoram': ['Aizawl', 'Lunglei', 'Champhai'],
  'Nagaland': ['Kohima', 'Dimapur', 'Mokokchung'],
  'Odisha': ['Bhubaneswar', 'Cuttack', 'Rourkela', 'Berhampur', 'Sambalpur', 'Puri'],
  'Punjab': ['Chandigarh', 'Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Mohali'],
  'Rajasthan': ['Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Ajmer', 'Bikaner', 'Alwar'],
  'Sikkim': ['Gangtok', 'Namchi', 'Gyalshing'],
  'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem', 'Tirunelveli', 'Vellore', 'Erode'],
  'Telangana': ['Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Khammam'],
  'Tripura': ['Agartala', 'Dharmanagar', 'Udaipur'],
  'Uttar Pradesh': ['Noida', 'Lucknow', 'Kanpur', 'Ghaziabad', 'Agra', 'Varanasi', 'Meerut', 'Allahabad', 'Bareilly', 'Aligarh', 'Greater Noida'],
  'Uttarakhand': ['Dehradun', 'Haridwar', 'Roorkee', 'Haldwani', 'Rudrapur'],
  'West Bengal': ['Kolkata', 'Howrah', 'Durgapur', 'Asansol', 'Siliguri', 'Kharagpur'],
  'Andaman and Nicobar Islands': ['Port Blair'],
  'Chandigarh': ['Chandigarh'],
  'Dadra and Nagar Haveli and Daman and Diu': ['Daman', 'Diu', 'Silvassa'],
  'Delhi': ['New Delhi', 'Delhi', 'Noida', 'Greater Noida', 'Gurgaon', 'Faridabad', 'Ghaziabad'],
  'Jammu and Kashmir': ['Srinagar', 'Jammu', 'Anantnag', 'Baramulla'],
  'Ladakh': ['Leh', 'Kargil'],
  'Lakshadweep': ['Kavaratti'],
  'Puducherry': ['Puducherry', 'Karaikal', 'Mahe', 'Yanam']
};

// EMEA Major Cities (No states, direct city selection)
export const EMEA_CITIES = [
  // Western Europe - Germany
  'Berlin', 'Munich', 'Frankfurt', 'Hamburg', 'Cologne', 'Stuttgart', 'Dusseldorf', 'Dortmund', 'Essen', 'Leipzig', 'Bremen', 'Dresden', 'Hanover', 'Nuremberg',
  // Western Europe - France
  'Paris', 'Lyon', 'Marseille', 'Toulouse', 'Nice', 'Nantes', 'Strasbourg', 'Montpellier', 'Bordeaux', 'Lille', 'Rennes',
  // Western Europe - Netherlands
  'Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht', 'Eindhoven', 'Tilburg', 'Groningen', 'Almere',
  // Western Europe - Belgium
  'Brussels', 'Antwerp', 'Ghent', 'Bruges', 'Leuven', 'Liege',
  // Western Europe - Switzerland
  'Zurich', 'Geneva', 'Basel', 'Bern', 'Lausanne', 'Lucerne',
  // Western Europe - Austria
  'Vienna', 'Graz', 'Linz', 'Salzburg', 'Innsbruck',
  // Western Europe - Spain
  'Madrid', 'Barcelona', 'Valencia', 'Seville', 'Bilbao', 'Malaga', 'Zaragoza', 'Palma',
  // Western Europe - Italy
  'Milan', 'Rome', 'Turin', 'Naples', 'Florence', 'Bologna', 'Venice', 'Genoa', 'Padua',
  // Western Europe - Portugal
  'Lisbon', 'Porto', 'Braga', 'Coimbra', 'Faro',
  // Northern Europe - Sweden
  'Stockholm', 'Gothenburg', 'Malmo', 'Uppsala',
  // Northern Europe - Norway
  'Oslo', 'Bergen', 'Trondheim', 'Stavanger',
  // Northern Europe - Denmark
  'Copenhagen', 'Aarhus', 'Odense', 'Aalborg',
  // Northern Europe - Finland
  'Helsinki', 'Espoo', 'Tampere', 'Oulu', 'Turku',
  // Northern Europe - Iceland
  'Reykjavik',
  // Western Europe - Ireland
  'Dublin', 'Cork', 'Limerick', 'Galway',
  // Eastern Europe - Poland
  'Warsaw', 'Krakow', 'Wroclaw', 'Poznan', 'Gdansk',
  // Eastern Europe - Czech Republic
  'Prague', 'Brno', 'Ostrava',
  // Eastern Europe - Hungary
  'Budapest', 'Debrecen', 'Szeged',
  // Eastern Europe - Romania
  'Bucharest', 'Cluj-Napoca', 'Timisoara', 'Iasi',
  // Middle East - UAE
  'Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman',
  // Middle East - Saudi Arabia
  'Riyadh', 'Jeddah', 'Dammam', 'Mecca', 'Medina',
  // Middle East - Israel
  'Tel Aviv', 'Jerusalem', 'Haifa', 'Beersheba',
  // Middle East - Qatar
  'Doha',
  // Middle East - Kuwait
  'Kuwait City',
  // Middle East - Bahrain
  'Manama',
  // Middle East - Oman
  'Muscat',
  // Middle East - Jordan
  'Amman',
  // Middle East - Lebanon
  'Beirut',
  // Africa - South Africa
  'Cape Town', 'Johannesburg', 'Pretoria', 'Durban', 'Port Elizabeth',
  // Africa - Nigeria
  'Lagos', 'Abuja', 'Ibadan', 'Kano',
  // Africa - Kenya
  'Nairobi', 'Mombasa', 'Kisumu',
  // Africa - Egypt
  'Cairo', 'Alexandria', 'Giza',
  // Africa - Morocco
  'Casablanca', 'Rabat', 'Marrakech', 'Fez',
  // Africa - Ghana
  'Accra', 'Kumasi',
  // Africa - Ethiopia
  'Addis Ababa'
];

// Default cities for states not in the detailed list
export const getDefaultCities = () => [
  'Other (specify in job description)'
];
